import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik, yupToFormErrors } from 'formik';
import * as Yup from 'yup';

//import {Icon} from 'react-icons-kit';
//import  from 'react-icons-kit/feather/eyeOff';
//import {eye} from 'react-icons-kit/feather/eye'


//import eyeOff from '@mui/icons-material/VisibilityOff';

import {Icon} from 'react-icons-kit';
import {eyeOff} from 'react-icons-kit/feather/eyeOff';
import {eye} from 'react-icons-kit/feather/eye'

//import {Icon} from '@mui/icons-material';
//import eye from '@mui/icons-material/Visibility';
import { useDispatch, useSelector } from 'react-redux';
import { errorHelper,Loader } from '../../utils/tools'

import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button';
import { errorGlobal, successGlobal } from '../../store/reducers/notifications';

import { updateUserPsw, signInUser } from '../../store/actions/users';


const ChangePsw = () => {
    // comp
    const [register,setRegister] = useState(false);
    let navigate = useNavigate()
    // redux
    const users = useSelector( state => state.users);
    const notifications = useSelector( state => state.notifications)
    const dispatch = useDispatch();


    //const [password, setPassword] = useState("");
    //const [type, setType] = useState('password');
    //const [icon, setIcon] = useState(eyeOff);
    
const [password, setPassword] = useState("");
const [type, setType] = useState('password');
const [icon, setIcon] = useState(eyeOff);


const [password1, setPassword1] = useState("");
const [type1, setType1] = useState('password');
const [icon1, setIcon1] = useState(eyeOff);

const [password2, setPassword2] = useState("");
const [type2, setType2] = useState('password');
const [icon2, setIcon2] = useState(eyeOff);
    


    const handleToggle = () => {
        if (type==='password'){
           setIcon(eye);
           setType('text')
        } else {
           setIcon(eyeOff)
           setType('password')
        }
     }


     const handleToggle1 = () => {
        if (type==='password'){
           setIcon1(eye);
           setType1('text')
        } else {
           setIcon1(eyeOff)
           setType1('password')
        }
     }


     const handleToggle2 = () => {
        if (type==='password'){
           setIcon2(eye);
           setType2('text')
        } else {
           setIcon2(eyeOff)
           setType2('password')
        }
     }

     const divStyle = {
        display: 'flex',
        alignItems: 'center'
      };

    const formik = useFormik({
        initialValues:{
            


        oldpassword:"",
        newpassword1:'',
        newpassword2:''
        },
        validationSchema: Yup.object({
            
            oldpassword:Yup.string()
            .required('Sorry  old password is required'),
            newpassword1:Yup.string()
            .required('Sorry new  password is required'),
            newpassword2:Yup.string()
            .required('news password not matching ')
            
        }),
        onSubmit:(values)=>{
            handleSubmit(values)
        }
    })

    const handleSubmit = (values) => {
        console.log("55555");
        console.log(values);
        console.log("55");
        


        if(values.newpassword1===values.newpassword2){
            
            dispatch(updateUserPsw(values))
        } else {
            dispatch(errorGlobal("NEW PASSWORDS IS NOT MATCHING"))
        }
    }
    const handleRegOrLogin = () => {
        if(register){

            
            setRegister(!register)
            navigate('/auth')
        } else {
            //dispatch(signInUser(values))
            setRegister(!register)
            navigate('/auth')
        }
    }

    useEffect(()=>{
        if(notifications && notifications.global.success){
            navigate('/auth')
        }
    },[notifications])


    return(
        <div className='auth_container'>
            <h4>Change password</h4>
            { users.loading ?
                <Loader/>
            :
            <Box
                sx={{
                    '& .MuiTextField-root': { width:'120%',marginTop:'20px' },
                }}
                component="form"
                onSubmit={formik.handleSubmit}
            >


<div style={divStyle}>
             
            <TextField
                    name="oldpassword"
                    label="Enter your  old password"
                   
                    variant='outlined'

                    type={type1}
                    value={password1}
                    onChange={(e) => setPassword1(e.target.value)}
                    {...formik.getFieldProps('oldpassword')}
                    {...errorHelper(formik,'oldpassword')}
                />

<span class="flex justify-around items-center" onClick={handleToggle1}>
                  <Icon class="absolute mr-10" icon={icon} size={30}/>
              </span>
              
            </div>
           

  
  <div style={divStyle}>

                
              <TextField
                    name="newpassword1"
                    label="Enter your new password"
                    type={type}
        
                    value={password}
                    variant='outlined'
                    onChange={(e) => setPassword(e.target.value)}
                   
                    {...formik.getFieldProps('newpassword1')}
                    {...errorHelper(formik,'newpassword1')}
                    />
                <span class="flex justify-around items-center" onClick={handleToggle}>
                  <Icon class="absolute mr-10" icon={icon} size={30}/>
              </span>
              
            </div>
           
            <div style={divStyle}>
                
              <TextField
                    name="newpassword2"
                    label="Enter your new password"
                    type={type2}
                   value={password2}
                    variant='outlined'
                    onChange={(e) => setPassword2(e.target.value)}
                    {...formik.getFieldProps('newpassword2')}
                    {...errorHelper(formik,'newpassword2')}
                />
                <span class="flex justify-around items-center" onClick={handleToggle2}>
                  <Icon class="absolute mr-10" icon={icon} size={30}/>
              </span>
              
            </div>
                <div className='mt-2'>
                    <Button variant='contained' color="primary" type="submit" size="large">
                        { register ? 'update password': 'update password'}
                    </Button>
                    
                </div>
            </Box>
            }

        </div>
    )
}

export default ChangePsw